import classNames from "classnames";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import AuthHeader from "src/components/@auth/auth-layout/auth-header";
import { EyeClosedIcon, EyeIcon } from "src/components/icons";
import PrimaryButton from "src/components/reusable/button/primary-button";
import AppFooter from "src/layouts/footer";

const PASSWORD = "perceiveAI@2025"; // Replace with your desired password

const DropboxLogin = ({ companyName, text }: { companyName?: string; text?: string }) => {
  const [inputPassword, setInputPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [isPasswordVisible, setIsPasswordVisible] = useState(false);

  const handleLogin = () => {
    if (inputPassword === PASSWORD) {
      localStorage.setItem("dropboxAccess", "granted");
      navigate("/dropbox", { replace: true,
        state: { companyName },
       });
    } else {
      setError("Incorrect password. Please try again.");
    }
  };

  return (
    <>
      <AuthHeader />
      <div className="min-h-[calc(100vh-90px)] flex items-center justify-center bg-gradient-to-br from-gray-50 via-gray-100 to-gray-200 px-4">
  <div className="w-full max-w-md bg-white/80 backdrop-blur-md rounded-2xl shadow-lg p-8 border border-gray-200">
    
    {/* Company Info */}
    {/* {companyName && (
      <h2 className="text-3xl font-semibold text-gray-700 text-center mb-1">
        {companyName}
      </h2>
    )} */}
    {text && (
      <p className="text-xl text-gray-800 text-center mb-4">{text}</p>
    )}

    {/* Title */}
    <h1 className="text-sm font-semibold text-gray-500 ">
      Enter your password to login
    </h1>

    {/* Input */}
    <fieldset className="mt-3">
      <div className="relative">
        <input
          id="password"
          type={isPasswordVisible ? "text" : "password"}
          value={inputPassword}
          onChange={(e) => setInputPassword(e.target.value)}
          placeholder="Enter Password"
          className={classNames(
                  "appearance-none block w-full px-2 py-[10px] border-[1px] border-[#87888C] rounded-full placeholder:text-gray-400 focus:ring-0.5",
                  "border-gray-400 focus:border-primary-500 focus:ring-primary-500",
          )}
        />
        {inputPassword && (
          <div
                  className="absolute top-0 right-2 h-full flex items-center text-gray-600 cursor-pointer"
            onClick={() => setIsPasswordVisible(!isPasswordVisible)}
          >
            {isPasswordVisible ? <EyeClosedIcon /> : <EyeIcon />}
          </div>
        )}
      </div>
    </fieldset>

          {error && <p className="text-red-600 text-sm mb-2">{error}</p>}
          <div className="flex justify-center w-full mt-3">
            {/* <Button
            classname="w-full"
            htmlType="submit"
            disabled={isSubmitting || isGoogleSubmitting}
            loading={isSubmitting}
            type="primary"
            rounded="full"
          >
            Sign In
          </Button> */}
            <PrimaryButton className="w-full" type="button" onClick={handleLogin} text="Sign In" />
    </div>
  </div>
</div>
      <AppFooter />
    </>
  );
};

export default DropboxLogin;
